import { getPathDataFromState } from "../fork/getPathFromState";
import { stripBaseUrl } from "../fork/getStateFromPath-mods";
import { getNormalizedStatePath } from "./getNormalizedStatePath";
import { isIndexPath } from "./isIndexPath";
import { getResolvedLinking } from "./linkingConfig";
import { stripPathSuffix } from "./path";
function getRouteInfo(state) {
  return getRouteInfoFromState(function(state2, asPath) {
    var _getResolvedLinking;
    return getPathDataFromState(state2, {
      screens: [],
      ...(_getResolvedLinking = getResolvedLinking()) === null || _getResolvedLinking === void 0 ? void 0 : _getResolvedLinking.config,
      preserveDynamicRoutes: asPath,
      preserveGroups: asPath
    });
  }, state);
}
function getRouteInfoFromState(getPathFromState, state, baseUrl) {
  var { path } = getPathFromState(state, false);
  var qualified = getPathFromState(state, true);
  return {
    unstable_globalHref: path,
    // a hash href serializes as /page#section; the pathname the router compares
    // against pending navigation and the URL must drop the hash as well as the query
    pathname: stripPathSuffix(stripBaseUrl(path, baseUrl)),
    isIndex: isIndexPath(state),
    ...getNormalizedStatePath(qualified, baseUrl)
  };
}
export {
  getRouteInfo,
  getRouteInfoFromState
};
//# sourceMappingURL=getRouteInfo.js.map
